<app-maps-field-dashboard *ngIf="checkData" [coordinates]="objMapArray" ></app-maps-field-dashboard>
